'use client';

import { useBoolean } from 'usehooks-ts';

import {
  AccessibleAccordion,
  AccessibleAccordionButton,
  AccessibleAccordionHeading,
  AccessibleAccordionItem,
  AccessibleAccordionPanel,
  buttonVariants,
  Card,
  CaretDownIcon,
  CaretUpIcon,
  TypographyDescription,
} from '@/components';
import type { Category } from '@/types';

type CategoryContentProps = Category;

const CategoryContent = ({ description }: CategoryContentProps) => {
  const { value: expanded, setValue: setExpanded } = useBoolean();

  if (description) {
    const regex = new RegExp(/^s*<p\b[^>]*>.*?<\/p>/gim);
    const summary = description.match(regex);
    const content = description.replace(regex, '');

    return (
      <AccessibleAccordion
        allowZeroExpanded
        onChange={() => setExpanded(!expanded)}
      >
        <Card className='relative pb-10'>
          <AccessibleAccordionItem dangerouslySetExpanded={expanded}>
            {summary ? (
              <TypographyDescription description={summary[0]} />
            ) : null}
            <AccessibleAccordionHeading>
              <AccessibleAccordionButton
                className={buttonVariants({
                  variant: 'outline',
                  size: 'lg',
                  className:
                    'absolute inset-x-0 bottom-0 mx-auto max-w-max translate-y-1/2 justify-between gap-4 !px-4 outline outline-4 outline-background',
                })}
              >
                {expanded ? (
                  <>
                    <span>کمتر</span>
                    <CaretUpIcon className='animate-in' />
                  </>
                ) : (
                  <>
                    <span>بیشتر</span>
                    <CaretDownIcon className='animate-in' />
                  </>
                )}
              </AccessibleAccordionButton>
            </AccessibleAccordionHeading>
            <AccessibleAccordionPanel className='pt-4'>
              <TypographyDescription description={content} />
            </AccessibleAccordionPanel>
          </AccessibleAccordionItem>
        </Card>
      </AccessibleAccordion>
    );
  }
};

export { CategoryContent };
